import Api from '@/api/Api'
import store from '../store'

export default {

  async getList (params) {
    return store.dispatch('checkResponseApi', await Api().get('pos/qrcodes', { params }))
  },

  async generate (data) {
    const options = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    return store.dispatch('checkResponseApi', await Api().post('pos/qrcodes/generate', data, options))
  },

  async delete (qrcodeId) {
    let options = {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    }
    return store.dispatch('checkResponseApi', await Api().delete(`pos/qrcodes/${qrcodeId}`, {}, options))
  },

}



// WEBPACK FOOTER //
// ./src/api/PosQRCodeService.js